
import { Vue, Component } from 'vue-property-decorator';
import lazyInject from '@/di';
import DownloadService from '@/services/download.service';

@Component
export default class Download extends Vue {
  @lazyInject(DownloadService)
  private downloadService!: DownloadService;

  text = '';

  async handleDownload() {
    if (!this.text) {
      this.$message.error('请输入下载地址');
      return;
    }
    const res = await this.downloadService.download(this.text);
    const downloadUrl = this.text.split('bi/')[1].split('.xlsx')[0];
    const _t = decodeURIComponent(downloadUrl);
    const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = _t;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}
